<script lang="ts">
  import FormField from '../../components/FormField.svelte'
  import type { Draft } from '$lib/public/wizard-state'

  interface Props {
    person: Draft['person']
  }
  let { person = $bindable() }: Props = $props()
</script>

<h2 tabindex="-1">How can we reach you?</h2>
<p class="muted">Step two of three.</p>

<FormField label="First name" name="person-firstName" bind:value={person.firstName} required />
<FormField label="Last name" name="person-lastName" bind:value={person.lastName} required />
<FormField
  label="Email address"
  name="person-email"
  type="email"
  bind:value={person.email}
  required
/>

<style>
  h2 {
    margin: 0 0 4px;
    font-size: 1.4rem;
    color: var(--ink-strong);
  }
  h2:focus {
    outline: none;
  }
  .muted {
    margin: 0 0 20px;
    color: var(--muted);
  }
</style>
